"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * AAS Template repository API
 * The API implemented by the AAS repository
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessApi = exports.AccessApiFactory = exports.AccessApiFp = exports.AccessApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
const common_1 = require("../common");
const base_1 = require("../base");
/**
 * AccessApi - axios parameter creator
 * @export
 */
const AccessApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Submit a new rolebinding where the given group is the resource
         * @param {string} groupId
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupRoleBinding: async (groupId, roleBinding, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            common_1.assertParamExists('addGroupRoleBinding', 'groupId', groupId);
            const localVarPath = `/access/group/{groupId}/rolebindings`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleBinding, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a new rolebinding where the given label is the resource
         * @param {string} labelId
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLabelRoleBinding: async (labelId, roleBinding, options = {}) => {
            // verify required parameter 'labelId' is not null or undefined
            common_1.assertParamExists('addLabelRoleBinding', 'labelId', labelId);
            const localVarPath = `/label/{labelId}/rolebindings`
                .replace(`{${"labelId"}}`, encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleBinding, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a new role binding where the given template is the resource
         * @param {string} templateHash
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTemplateRoleBinding: async (templateHash, roleBinding, options = {}) => {
            // verify required parameter 'templateHash' is not null or undefined
            common_1.assertParamExists('addTemplateRoleBinding', 'templateHash', templateHash);
            const localVarPath = `/template/aas/{templateHash}/rolebindings`
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleBinding, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new group
         * @param {Group} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: async (group, options = {}) => {
            const localVarPath = `/access/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(group, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete group by id
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            common_1.assertParamExists('deleteGroup', 'groupId', groupId);
            const localVarPath = `/access/group/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing invite token
         * @param {string} groupId
         * @param {string} inviteToken The invite token to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInviteToken: async (groupId, inviteToken, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            common_1.assertParamExists('deleteInviteToken', 'groupId', groupId);
            // verify required parameter 'inviteToken' is not null or undefined
            common_1.assertParamExists('deleteInviteToken', 'inviteToken', inviteToken);
            const localVarPath = `/access/group/{groupId}/invite/{inviteToken}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"inviteToken"}}`, encodeURIComponent(String(inviteToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove user by id
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            common_1.assertParamExists('deleteUser', 'userId', userId);
            const localVarPath = `/access/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate an invite token for a particular group
         * @param {string} groupId
         * @param {InviteInfo} [inviteInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateInviteToken: async (groupId, inviteInfo, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            common_1.assertParamExists('generateInviteToken', 'groupId', groupId);
            const localVarPath = `/access/group/{groupId}/invite`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inviteInfo, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List existing invite tokens for a particular group
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInviteTokens: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            common_1.assertParamExists('listInviteTokens', 'groupId', groupId);
            const localVarPath = `/access/group/{groupId}/invite`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a new rolebinding where the given user is the bearer
         * @param {string} userId
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserRoleBinding: async (userId, roleBinding, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            common_1.assertParamExists('modifyUserRoleBinding', 'userId', userId);
            const localVarPath = `/access/user/{userId}/rolebindings`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleBinding, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a generated invite token to onboard a user
         * @param {OnboardingRequest} [onboardingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardUser: async (onboardingRequest, options = {}) => {
            const localVarPath = `/access/group/onboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(onboardingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the role binding for the given group and bearer
         * @param {string} groupId
         * @param {BearerType} bearerType
         * @param {string} bearerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupRoleBindingByBearer: async (groupId, bearerType, bearerId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            common_1.assertParamExists('removeGroupRoleBindingByBearer', 'groupId', groupId);
            // verify required parameter 'bearerType' is not null or undefined
            common_1.assertParamExists('removeGroupRoleBindingByBearer', 'bearerType', bearerType);
            // verify required parameter 'bearerId' is not null or undefined
            common_1.assertParamExists('removeGroupRoleBindingByBearer', 'bearerId', bearerId);
            const localVarPath = `/access/group/{groupId}/rolebinding/{bearerType}/{bearerId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"bearerType"}}`, encodeURIComponent(String(bearerType)))
                .replace(`{${"bearerId"}}`, encodeURIComponent(String(bearerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the role binding for the given label and bearer
         * @param {string} labelId
         * @param {BearerType} bearerType
         * @param {string} bearerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLabelRoleBindingByBearer: async (labelId, bearerType, bearerId, options = {}) => {
            // verify required parameter 'labelId' is not null or undefined
            common_1.assertParamExists('removeLabelRoleBindingByBearer', 'labelId', labelId);
            // verify required parameter 'bearerType' is not null or undefined
            common_1.assertParamExists('removeLabelRoleBindingByBearer', 'bearerType', bearerType);
            // verify required parameter 'bearerId' is not null or undefined
            common_1.assertParamExists('removeLabelRoleBindingByBearer', 'bearerId', bearerId);
            const localVarPath = `/label/{labelId}/rolebinding/{bearerType}/{bearerId}`
                .replace(`{${"labelId"}}`, encodeURIComponent(String(labelId)))
                .replace(`{${"bearerType"}}`, encodeURIComponent(String(bearerType)))
                .replace(`{${"bearerId"}}`, encodeURIComponent(String(bearerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the role binding for the given template and bearer
         * @param {string} templateHash
         * @param {BearerType} bearerType
         * @param {string} bearerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTemplateRoleBindingByBearer: async (templateHash, bearerType, bearerId, options = {}) => {
            // verify required parameter 'templateHash' is not null or undefined
            common_1.assertParamExists('removeTemplateRoleBindingByBearer', 'templateHash', templateHash);
            // verify required parameter 'bearerType' is not null or undefined
            common_1.assertParamExists('removeTemplateRoleBindingByBearer', 'bearerType', bearerType);
            // verify required parameter 'bearerId' is not null or undefined
            common_1.assertParamExists('removeTemplateRoleBindingByBearer', 'bearerId', bearerId);
            const localVarPath = `/template/aas/{templateHash}/rolebinding/{bearerType}/{bearerId}`
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)))
                .replace(`{${"bearerType"}}`, encodeURIComponent(String(bearerType)))
                .replace(`{${"bearerId"}}`, encodeURIComponent(String(bearerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the rolebindings for all accessible Groups.
         * @param {string} [userId] Get groups accessible for userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllGroupRoleBindings: async (userId, options = {}) => {
            const localVarPath = `/access/groups/rolebindings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the rolebindings for all accessible AAS templates.
         * @param {string} [userId] Get templates accessible for userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllTemplateRoleBindings: async (userId, options = {}) => {
            const localVarPath = `/templates/aas/rolebindings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a specific group by its id
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGroup: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            common_1.assertParamExists('retrieveGroup', 'groupId', groupId);
            const localVarPath = `/access/group/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all role bindings for which the given group is the bearer.
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGroupRoleBindings: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            common_1.assertParamExists('retrieveGroupRoleBindings', 'groupId', groupId);
            const localVarPath = `/access/group/{groupId}/rolebindings`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve groups
         * @param {string} [userId] Get groups for userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGroups: async (userId, options = {}) => {
            const localVarPath = `/access/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all role bindings for a given label
         * @param {string} labelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLabelRoleBindings: async (labelId, options = {}) => {
            // verify required parameter 'labelId' is not null or undefined
            common_1.assertParamExists('retrieveLabelRoleBindings', 'labelId', labelId);
            const localVarPath = `/label/{labelId}/rolebindings`
                .replace(`{${"labelId"}}`, encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all role bindings for the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePlatformRoleBindings: async (options = {}) => {
            const localVarPath = `/access/platform/rolebindings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get role bindings for this template
         * @param {string} templateHash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTemplateRoleBindings: async (templateHash, options = {}) => {
            // verify required parameter 'templateHash' is not null or undefined
            common_1.assertParamExists('retrieveTemplateRoleBindings', 'templateHash', templateHash);
            const localVarPath = `/template/aas/{templateHash}/rolebindings`
                .replace(`{${"templateHash"}}`, encodeURIComponent(String(templateHash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a single user\'s <b>public</b> info
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUser: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            common_1.assertParamExists('retrieveUser', 'userId', userId);
            const localVarPath = `/access/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all role bindings for a given user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserRoleBindings: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            common_1.assertParamExists('retrieveUserRoleBindings', 'userId', userId);
            const localVarPath = `/access/user/{userId}/rolebindings`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve existing users
         * @param {string} [displayName] Find matching users by displayName (regex)
         * @param {string} [email] Find matching users by e-mail (exact match)
         * @param {Array<string>} [userIds] Get users by userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUsers: async (displayName, email, userIds, options = {}) => {
            const localVarPath = `/access/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            if (displayName !== undefined) {
                localVarQueryParameter['displayName'] = displayName;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update group by id
         * @param {string} groupId
         * @param {Group} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup: async (groupId, group, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            common_1.assertParamExists('updateGroup', 'groupId', groupId);
            const localVarPath = `/access/group/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication session-user required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(group, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AccessApiAxiosParamCreator = AccessApiAxiosParamCreator;
/**
 * AccessApi - functional programming interface
 * @export
 */
const AccessApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccessApiAxiosParamCreator(configuration);
    return {
        /**
         * Submit a new rolebinding where the given group is the resource
         * @param {string} groupId
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addGroupRoleBinding(groupId, roleBinding, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addGroupRoleBinding(groupId, roleBinding, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Submit a new rolebinding where the given label is the resource
         * @param {string} labelId
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addLabelRoleBinding(labelId, roleBinding, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addLabelRoleBinding(labelId, roleBinding, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Submit a new role binding where the given template is the resource
         * @param {string} templateHash
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTemplateRoleBinding(templateHash, roleBinding, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTemplateRoleBinding(templateHash, roleBinding, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Create new group
         * @param {Group} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroup(group, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroup(group, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Delete group by id
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroup(groupId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroup(groupId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Delete an existing invite token
         * @param {string} groupId
         * @param {string} inviteToken The invite token to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInviteToken(groupId, inviteToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInviteToken(groupId, inviteToken, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Remove user by id
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Generate an invite token for a particular group
         * @param {string} groupId
         * @param {InviteInfo} [inviteInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateInviteToken(groupId, inviteInfo, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateInviteToken(groupId, inviteInfo, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * List existing invite tokens for a particular group
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInviteTokens(groupId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInviteTokens(groupId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Submit a new rolebinding where the given user is the bearer
         * @param {string} userId
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modifyUserRoleBinding(userId, roleBinding, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modifyUserRoleBinding(userId, roleBinding, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Submit a generated invite token to onboard a user
         * @param {OnboardingRequest} [onboardingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async onboardUser(onboardingRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.onboardUser(onboardingRequest, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Delete the role binding for the given group and bearer
         * @param {string} groupId
         * @param {BearerType} bearerType
         * @param {string} bearerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeGroupRoleBindingByBearer(groupId, bearerType, bearerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeGroupRoleBindingByBearer(groupId, bearerType, bearerId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Delete the role binding for the given label and bearer
         * @param {string} labelId
         * @param {BearerType} bearerType
         * @param {string} bearerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLabelRoleBindingByBearer(labelId, bearerType, bearerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeLabelRoleBindingByBearer(labelId, bearerType, bearerId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Delete the role binding for the given template and bearer
         * @param {string} templateHash
         * @param {BearerType} bearerType
         * @param {string} bearerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTemplateRoleBindingByBearer(templateHash, bearerType, bearerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTemplateRoleBindingByBearer(templateHash, bearerType, bearerId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieves the rolebindings for all accessible Groups.
         * @param {string} [userId] Get groups accessible for userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveAllGroupRoleBindings(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveAllGroupRoleBindings(userId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieves the rolebindings for all accessible AAS templates.
         * @param {string} [userId] Get templates accessible for userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveAllTemplateRoleBindings(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveAllTemplateRoleBindings(userId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieve a specific group by its id
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveGroup(groupId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveGroup(groupId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieve all role bindings for which the given group is the bearer.
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveGroupRoleBindings(groupId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveGroupRoleBindings(groupId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieve groups
         * @param {string} [userId] Get groups for userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveGroups(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveGroups(userId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieve all role bindings for a given label
         * @param {string} labelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveLabelRoleBindings(labelId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveLabelRoleBindings(labelId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieve all role bindings for the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrievePlatformRoleBindings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrievePlatformRoleBindings(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get role bindings for this template
         * @param {string} templateHash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveTemplateRoleBindings(templateHash, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveTemplateRoleBindings(templateHash, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieve a single user\'s <b>public</b> info
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveUser(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveUser(userId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieve all role bindings for a given user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveUserRoleBindings(userId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveUserRoleBindings(userId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieve existing users
         * @param {string} [displayName] Find matching users by displayName (regex)
         * @param {string} [email] Find matching users by e-mail (exact match)
         * @param {Array<string>} [userIds] Get users by userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveUsers(displayName, email, userIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveUsers(displayName, email, userIds, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Update group by id
         * @param {string} groupId
         * @param {Group} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroup(groupId, group, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroup(groupId, group, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.AccessApiFp = AccessApiFp;
/**
 * AccessApi - factory interface
 * @export
 */
const AccessApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccessApiFp(configuration);
    return {
        /**
         * Submit a new rolebinding where the given group is the resource
         * @param {string} groupId
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupRoleBinding(groupId, roleBinding, options) {
            return localVarFp.addGroupRoleBinding(groupId, roleBinding, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a new rolebinding where the given label is the resource
         * @param {string} labelId
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLabelRoleBinding(labelId, roleBinding, options) {
            return localVarFp.addLabelRoleBinding(labelId, roleBinding, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a new role binding where the given template is the resource
         * @param {string} templateHash
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTemplateRoleBinding(templateHash, roleBinding, options) {
            return localVarFp.addTemplateRoleBinding(templateHash, roleBinding, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new group
         * @param {Group} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(group, options) {
            return localVarFp.createGroup(group, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete group by id
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(groupId, options) {
            return localVarFp.deleteGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing invite token
         * @param {string} groupId
         * @param {string} inviteToken The invite token to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInviteToken(groupId, inviteToken, options) {
            return localVarFp.deleteInviteToken(groupId, inviteToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove user by id
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId, options) {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate an invite token for a particular group
         * @param {string} groupId
         * @param {InviteInfo} [inviteInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateInviteToken(groupId, inviteInfo, options) {
            return localVarFp.generateInviteToken(groupId, inviteInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * List existing invite tokens for a particular group
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInviteTokens(groupId, options) {
            return localVarFp.listInviteTokens(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a new rolebinding where the given user is the bearer
         * @param {string} userId
         * @param {RoleBinding} [roleBinding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserRoleBinding(userId, roleBinding, options) {
            return localVarFp.modifyUserRoleBinding(userId, roleBinding, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a generated invite token to onboard a user
         * @param {OnboardingRequest} [onboardingRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardUser(onboardingRequest, options) {
            return localVarFp.onboardUser(onboardingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the role binding for the given group and bearer
         * @param {string} groupId
         * @param {BearerType} bearerType
         * @param {string} bearerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupRoleBindingByBearer(groupId, bearerType, bearerId, options) {
            return localVarFp.removeGroupRoleBindingByBearer(groupId, bearerType, bearerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the role binding for the given label and bearer
         * @param {string} labelId
         * @param {BearerType} bearerType
         * @param {string} bearerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLabelRoleBindingByBearer(labelId, bearerType, bearerId, options) {
            return localVarFp.removeLabelRoleBindingByBearer(labelId, bearerType, bearerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the role binding for the given template and bearer
         * @param {string} templateHash
         * @param {BearerType} bearerType
         * @param {string} bearerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTemplateRoleBindingByBearer(templateHash, bearerType, bearerId, options) {
            return localVarFp.removeTemplateRoleBindingByBearer(templateHash, bearerType, bearerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the rolebindings for all accessible Groups.
         * @param {string} [userId] Get groups accessible for userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllGroupRoleBindings(userId, options) {
            return localVarFp.retrieveAllGroupRoleBindings(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the rolebindings for all accessible AAS templates.
         * @param {string} [userId] Get templates accessible for userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAllTemplateRoleBindings(userId, options) {
            return localVarFp.retrieveAllTemplateRoleBindings(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a specific group by its id
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGroup(groupId, options) {
            return localVarFp.retrieveGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all role bindings for which the given group is the bearer.
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGroupRoleBindings(groupId, options) {
            return localVarFp.retrieveGroupRoleBindings(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve groups
         * @param {string} [userId] Get groups for userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGroups(userId, options) {
            return localVarFp.retrieveGroups(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all role bindings for a given label
         * @param {string} labelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveLabelRoleBindings(labelId, options) {
            return localVarFp.retrieveLabelRoleBindings(labelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all role bindings for the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePlatformRoleBindings(options) {
            return localVarFp.retrievePlatformRoleBindings(options).then((request) => request(axios, basePath));
        },
        /**
         * Get role bindings for this template
         * @param {string} templateHash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveTemplateRoleBindings(templateHash, options) {
            return localVarFp.retrieveTemplateRoleBindings(templateHash, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a single user\'s <b>public</b> info
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUser(userId, options) {
            return localVarFp.retrieveUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all role bindings for a given user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUserRoleBindings(userId, options) {
            return localVarFp.retrieveUserRoleBindings(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve existing users
         * @param {string} [displayName] Find matching users by displayName (regex)
         * @param {string} [email] Find matching users by e-mail (exact match)
         * @param {Array<string>} [userIds] Get users by userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUsers(displayName, email, userIds, options) {
            return localVarFp.retrieveUsers(displayName, email, userIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Update group by id
         * @param {string} groupId
         * @param {Group} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(groupId, group, options) {
            return localVarFp.updateGroup(groupId, group, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AccessApiFactory = AccessApiFactory;
/**
 * AccessApi - object-oriented interface
 * @export
 * @class AccessApi
 * @extends {BaseAPI}
 */
class AccessApi extends base_1.BaseAPI {
    /**
     * Submit a new rolebinding where the given group is the resource
     * @param {string} groupId
     * @param {RoleBinding} [roleBinding]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    addGroupRoleBinding(groupId, roleBinding, options) {
        return exports.AccessApiFp(this.configuration).addGroupRoleBinding(groupId, roleBinding, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit a new rolebinding where the given label is the resource
     * @param {string} labelId
     * @param {RoleBinding} [roleBinding]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    addLabelRoleBinding(labelId, roleBinding, options) {
        return exports.AccessApiFp(this.configuration).addLabelRoleBinding(labelId, roleBinding, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit a new role binding where the given template is the resource
     * @param {string} templateHash
     * @param {RoleBinding} [roleBinding]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    addTemplateRoleBinding(templateHash, roleBinding, options) {
        return exports.AccessApiFp(this.configuration).addTemplateRoleBinding(templateHash, roleBinding, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create new group
     * @param {Group} [group]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    createGroup(group, options) {
        return exports.AccessApiFp(this.configuration).createGroup(group, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete group by id
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    deleteGroup(groupId, options) {
        return exports.AccessApiFp(this.configuration).deleteGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete an existing invite token
     * @param {string} groupId
     * @param {string} inviteToken The invite token to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    deleteInviteToken(groupId, inviteToken, options) {
        return exports.AccessApiFp(this.configuration).deleteInviteToken(groupId, inviteToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove user by id
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    deleteUser(userId, options) {
        return exports.AccessApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Generate an invite token for a particular group
     * @param {string} groupId
     * @param {InviteInfo} [inviteInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    generateInviteToken(groupId, inviteInfo, options) {
        return exports.AccessApiFp(this.configuration).generateInviteToken(groupId, inviteInfo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List existing invite tokens for a particular group
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    listInviteTokens(groupId, options) {
        return exports.AccessApiFp(this.configuration).listInviteTokens(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit a new rolebinding where the given user is the bearer
     * @param {string} userId
     * @param {RoleBinding} [roleBinding]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    modifyUserRoleBinding(userId, roleBinding, options) {
        return exports.AccessApiFp(this.configuration).modifyUserRoleBinding(userId, roleBinding, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Submit a generated invite token to onboard a user
     * @param {OnboardingRequest} [onboardingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    onboardUser(onboardingRequest, options) {
        return exports.AccessApiFp(this.configuration).onboardUser(onboardingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete the role binding for the given group and bearer
     * @param {string} groupId
     * @param {BearerType} bearerType
     * @param {string} bearerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    removeGroupRoleBindingByBearer(groupId, bearerType, bearerId, options) {
        return exports.AccessApiFp(this.configuration).removeGroupRoleBindingByBearer(groupId, bearerType, bearerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete the role binding for the given label and bearer
     * @param {string} labelId
     * @param {BearerType} bearerType
     * @param {string} bearerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    removeLabelRoleBindingByBearer(labelId, bearerType, bearerId, options) {
        return exports.AccessApiFp(this.configuration).removeLabelRoleBindingByBearer(labelId, bearerType, bearerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete the role binding for the given template and bearer
     * @param {string} templateHash
     * @param {BearerType} bearerType
     * @param {string} bearerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    removeTemplateRoleBindingByBearer(templateHash, bearerType, bearerId, options) {
        return exports.AccessApiFp(this.configuration).removeTemplateRoleBindingByBearer(templateHash, bearerType, bearerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves the rolebindings for all accessible Groups.
     * @param {string} [userId] Get groups accessible for userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrieveAllGroupRoleBindings(userId, options) {
        return exports.AccessApiFp(this.configuration).retrieveAllGroupRoleBindings(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves the rolebindings for all accessible AAS templates.
     * @param {string} [userId] Get templates accessible for userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrieveAllTemplateRoleBindings(userId, options) {
        return exports.AccessApiFp(this.configuration).retrieveAllTemplateRoleBindings(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a specific group by its id
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrieveGroup(groupId, options) {
        return exports.AccessApiFp(this.configuration).retrieveGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all role bindings for which the given group is the bearer.
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrieveGroupRoleBindings(groupId, options) {
        return exports.AccessApiFp(this.configuration).retrieveGroupRoleBindings(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve groups
     * @param {string} [userId] Get groups for userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrieveGroups(userId, options) {
        return exports.AccessApiFp(this.configuration).retrieveGroups(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all role bindings for a given label
     * @param {string} labelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrieveLabelRoleBindings(labelId, options) {
        return exports.AccessApiFp(this.configuration).retrieveLabelRoleBindings(labelId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all role bindings for the platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrievePlatformRoleBindings(options) {
        return exports.AccessApiFp(this.configuration).retrievePlatformRoleBindings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get role bindings for this template
     * @param {string} templateHash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrieveTemplateRoleBindings(templateHash, options) {
        return exports.AccessApiFp(this.configuration).retrieveTemplateRoleBindings(templateHash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a single user\'s <b>public</b> info
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrieveUser(userId, options) {
        return exports.AccessApiFp(this.configuration).retrieveUser(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all role bindings for a given user
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrieveUserRoleBindings(userId, options) {
        return exports.AccessApiFp(this.configuration).retrieveUserRoleBindings(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve existing users
     * @param {string} [displayName] Find matching users by displayName (regex)
     * @param {string} [email] Find matching users by e-mail (exact match)
     * @param {Array<string>} [userIds] Get users by userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    retrieveUsers(displayName, email, userIds, options) {
        return exports.AccessApiFp(this.configuration).retrieveUsers(displayName, email, userIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update group by id
     * @param {string} groupId
     * @param {Group} [group]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    updateGroup(groupId, group, options) {
        return exports.AccessApiFp(this.configuration).updateGroup(groupId, group, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccessApi = AccessApi;
//# sourceMappingURL=access-api.js.map